import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function SearchSelectBox(props) {
  const {
    name,
    options,
    error,
    value,
    onChange,
    disabled,
    disableClearable,
    onBlur,
    widthValue,
  } = props;

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => (option.name ? option.name : '')}
      getOptionSelected={(option, valueObj) => option.id === valueObj.id}
      renderInput={(params) => <TextField {...params} autoComplete="off" variant="outlined" error={error} onBlur={onBlur} />}
      value={value}
      disabled={disabled}
      onChange={(_, selectValue) => {
        onChange({
          target: {
            name,
            value: selectValue,
          },
        });
      }}
      style={{ width: widthValue }}
      disableClearable={disableClearable}
      noOptionsText="データがありません"
    />
  );
}

SearchSelectBox.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired).isRequired,
  error: PropTypes.bool,
  value: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  disableClearable: PropTypes.bool,
  disabled: PropTypes.bool,
};

SearchSelectBox.defaultProps = {
  error: false,
  value: null,
  disableClearable: false,
  disabled: false,
};
